import React from "react";
import { CLIENT_PREFIX_PATH } from "constants/route.constant";
import { CLIENT, WELCOME, FREELANCER } from "constants/roles.constant";

const appsRoute = [
  {
    key: "apps.welcome",
    path: `${CLIENT_PREFIX_PATH}/welcome`,
    component: React.lazy(() => import("views/auth/welcome")),
    authority: [WELCOME],
  },
  {
    key: "apps.client",
    path: `${CLIENT_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/project/projectDashboard")),
    authority: [CLIENT, FREELANCER],
  },
  {
    key: "apps.gymprofile",
    path: `${CLIENT_PREFIX_PATH}/gym/profile`,
    component: React.lazy(() => import("views/gym/gymProfile")),
    authority: [CLIENT],
  },
  {
    key: "appTrainerManagement.addTrainer",
    path: `${CLIENT_PREFIX_PATH}/gym/trainer/list`,
    component: React.lazy(() => import("views/gym/trainer/trainerList")),
    authority: [CLIENT],
  },
  {
    key: "appTrainerManagement.trainerProfile",
    path: `${CLIENT_PREFIX_PATH}/gym/trainer-information/list`,
    component: React.lazy(() => import("views/gym/trainer/trainerProfile")),
    authority: [CLIENT],
  },
  {
    key: "appTrainerManagement.trainerProfile",
    path: `${CLIENT_PREFIX_PATH}/gym/trainer-information/list/view`,
    component: React.lazy(() =>
      import("views/gym/trainer/trainerProfile/components/trainerInfo")
    ),
    authority: [CLIENT],
  },
  {
    key: "appClientManagement.addClient",
    path: `${CLIENT_PREFIX_PATH}/gym/client/list`,
    component: React.lazy(() => import("views/gym/ourClient/clientList")),
    authority: [CLIENT, FREELANCER],
  },

  {
    key: "appClientManagement.clientProfile",
    path: `${CLIENT_PREFIX_PATH}/gym/client-information/list`,
    component: React.lazy(() => import("views/gym/ourClient/clientProfile")),
    authority: [CLIENT, FREELANCER],
  },
  {
    key: "appClientManagement.clientProfile",
    path: `${CLIENT_PREFIX_PATH}/gym/client-information/list/view`,
    component: React.lazy(() =>
      import("views/gym/ourClient/clientProfile/components/customerInfo")
    ),
    authority: [CLIENT, FREELANCER],
  },
  {
    key: "apps.reassignToTrainer",
    path: `${CLIENT_PREFIX_PATH}/gym/client-reassign-trainer`,
    component: React.lazy(() => import("views/gym/reassignClient")),
    authority: [CLIENT],
  },
  {
    key: "apps.transactionHistory",
    path: `${CLIENT_PREFIX_PATH}/gym/transaction-history`,
    component: React.lazy(() => import("views/gym/transactionHistory")),
    authority: [CLIENT, FREELANCER],
  },
  {
    key: "apps.contactUs",
    path: `${CLIENT_PREFIX_PATH}/gym/contactus`,
    component: React.lazy(() => import("views/gym/suggestToFeature")),
    authority: [CLIENT, FREELANCER],
  },
  {
    key: "apps.privacyPolicy",
    path: `${CLIENT_PREFIX_PATH}/gym/privacy-policy`,
    component: React.lazy(() => import("views/account/privacyPolicy")),
    authority: [CLIENT, FREELANCER],
  },
  // {
  //   key: "apps.contactUs",
  //   path: `${CLIENT_PREFIX_PATH}/gym/contact-us`,
  //   component: React.lazy(() => import("views/contactUs")),
  //   authority: [CLIENT],
  // },
];

export default appsRoute;
